import { render, staticRenderFns } from "./AllDicts.vue?vue&type=template&id=636986dd&scoped=true&"
import script from "./AllDicts.vue?vue&type=script&lang=js&"
export * from "./AllDicts.vue?vue&type=script&lang=js&"
import style0 from "./AllDicts.vue?vue&type=style&index=0&id=636986dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636986dd",
  null
  
)

export default component.exports